var actions = {
	next: "İleri",
	confirm: "Onaylayın",
	"continue": "Devam Edin"
};
var errors = {
	unknown: "Bilinmeyen bir hata oluştu",
	contactSupport: "Bir hata oluştu. Lütfen destek ile iletişime geçin.",
	tryAgain: "Bir hata oluştu. Lütfen tekrar deneyin.",
	submit: "Gönderiminizle ilgili bir hata oluştu."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "{name} ile oturum açın",
	signupWith: "{name} ile kaydolun"
};
var alreadyHaveAccount = {
	company: "Zaten bir {company} hesabınız var mı?",
	text: "Streamlabs ID’ye zaten sahip misiniz?",
	link: "Oturum açın"
};
var noAccount = {
	text: "Henüz bir hesabınız yok mu?",
	link: "Kaydolun"
};
var validation = {
	email: {
		invalid: "Lütfen geçerli bir e-posta girin"
	},
	password: {
		required: "Şifre gerekli",
		min: "Şifre 8 karakterden daha uzun olmalıdır",
		number: "Şifre bir rakam içermelidir",
		upper: "Şifre bir büyük harf içermelidir",
		special: "Şifre bir özel karakter içermelidir"
	},
	username: {
		invalid: "İsim en az 5 karakter uzunluğunda olmalıdır"
	},
	code: {
		minmax: "Kod 6 ile 10 karakter arasında olmalıdır"
	}
};
var poweredBy = "<company>Streamlabs</company> ile güçlendirilmiştir";
var card = {
	"404": {
		title: "Şirket bulunamadı!",
		desc: "Lütfen daha sonra yeniden deneyin veya destek ile iletişime geçin."
	},
	company: {
		logoAlt: "{company} Logosu"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6 haneli kimlik doğrulama kodu/8 haneli yedekleme kodu",
	successText: "Başarılı! Yeniden yönlendiriliyor...",
	remember: "Bu cihazı 30 günlüğüne hatırla"
};
var createTfa = {
	scan: {
		title: "2 Faktörlü Kimlik Doğrulamayı Etkinleştirin",
		lead: "Aşağıdaki koda tıklayın/kodu kopyalayın veya tercih ettiğiniz kimlik doğrulama uygulamasını kullanarak taratın. Kodlarınızı güvenle depolamak için <app0 />, <app1 /> veya <app2 /> gibi uygulamaları kullanmanızı öneririz.",
		copied: "Kopyalandı!",
		instructions: "Ya da bu kodu kimlik doğrulama uygulamanıza manuel olarak girin.",
		copy: "Kodu kopyalayın",
		proceed: "Onay"
	},
	confirm: {
		title: "2 Faktörlü Kimlik Doğrulamayı Onaylayın",
		lead: "İki Faktörlü Kimlik Doğrulamayı onaylamak ve etkinleştirmek için aşağıda oluşturulmuş İki Faktörlü Kimlik Doğrulama kodunu gönderin.",
		label: "İki Faktörlü Kimlik Doğrulama Kodu (6 haneli)",
		verify: "Kodu Doğrulayın",
		next: "Başarılı! Sonraki Adım"
	},
	save: {
		title: "Kurtarma Kodlarınızı Kaydedin",
		lead: "İki Faktörlü Kimlik Doğrulayıcınıza olan erişiminizi kaybetme ihtimalinize karşı aşağıdaki kurtarma kodlarınızı kaydedin. Bu modeli kapattıktan sonra buradaki kodlara tekrar erişemezsiniz.",
		label: "Kurtarma Kodları",
		download: "Kurtarma Kodlarını İndirin",
		copied: "Kodlar kopyalandı!",
		finished: "Tamamlandı"
	}
};
var emailLoginForm = {
	buttonText: "Oturum Açın",
	emailPlaceholder: "E-posta",
	passwordPlaceholder: "Şifre"
};
var emailSignupForm = {
	buttonText: "Kaydolun",
	emailPlaceholder: "Bir e-posta belirleyin",
	passwordPlaceholder: "Bir şifre belirleyin",
	usernamePlaceholder: "İsminiz",
	ageLabel: "Doğum Tarihi",
	agePlaceholder: "AA/GG/YYYY",
	agreeText: "Streamlabs’in <terms>Hizmet Şartları</terms> ve <privacy>Gizlilik Politikası</privacy>’nı kabul ediyorum.",
	agreeError: "Lütfen Streamlabs’in hüküm ve koşullarını kabul edin"
};
var ageInput = {
	invalidDate: "Lütfen geçerli bir doğum tarihi girin",
	futureDate: "Doğum günü geçmiş tarihli olmalı",
	minDate: "{year} yılından önceki tarihler girilemez",
	minAge_one: "Streamlabs’i kullanmak için {years} yaş veya üzeri olmalısınız",
	minAge_two: "Streamlabs’i kullanmak için {years} yaş veya üzeri olmalısınız",
	minAge_other: "Streamlabs’i kullanmak için {years} yaş veya üzeri olmalısınız"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-posta",
	back: "Oturum Açma Sayfasına Geri Dönün",
	successText: "Başarılı! Size bir şifre sıfırlama kodu gönderdik",
	buttonText: "E-postayı Sıfırlama Talebi",
	create: {
		successText: "Başarılı! Başlamanız için size bir doğrulama kodu gönderdik!",
		buttonText: "Doğrulama Kodu Talep Et"
	},
	errors: {
		notFound: "Bu e-posta adresiyle hiçbir hesap bulunamadı"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Şifrenizi mi unuttunuz?",
	lead: "Şifrenizi sıfırlamanız gerekiyorsa lütfen aşağıya e-postanızı girin; süreci başlatabilmeniz için size bir e-posta göndereceğiz.",
	resetTitle: "Şifrenizi Sıfırlayın",
	resetLead: "E-posta yoluyla bir kod almanız gerekirdi. Şifrenizi sıfırlamak için formu doldurun.",
	create: {
		title: "Şifrenizi oluşturun",
		lead: "Streamlabs ID oluşturduğunuz için tebrikler! Bir adım sonra Streamlabs’in tamamında giriş yapabileceksiniz!",
		resetTitle: "Bir şifre seçin",
		resetLead: "E-posta yoluyla bir kod almış olmanız gerekiyor. Bunu kullanın ve şifrenizi ayarlamak için formu doldurun."
	},
	successText: "Başarılı! Yeniden yönlendiriliyor...",
	signInTitle: "Zaten bir hesabınız var mı?",
	signInBtn: "Oturum Açın"
};
var checkTfaCard = {
	title: "2 Faktörlü Doğrulama Kontrolü",
	lead: "Devam etmek için lütfen İki Faktörlü Kimlik Doğrulama Kodu girin.",
	successText: "İki Faktörlü Kimlik Doğrulama başarılı bir şekilde onaylandı!",
	back: "Geri Gidin"
};
var verifyEmailCard = {
	title: "E-postanızı Doğrulayın",
	lead: "E-postanıza Streamlabs’ten 8 haneli kod gelip gelmediğini kontrol edin ve gelmişse kodu aşağıya girin.",
	back: "Geri Gidin",
	successText: "E-posta başarılı bir şekilde doğrulandı!"
};
var upgradeCard = {
	confirm: {
		title: "{company} bağlantısını onaylayın",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Devam ederek sağlanan e-posta ve parolayla {company} girişi yapabileceksiniz.",
			"ID'nizle Streamlabs'in tüm diğer ürünlerine erişebilir ve varsa diğer mevcut hesaplarınıza bağlanabilirsiniz.",
			"{company} hesabınız bu değişiklikten etkilenmeyecektir."
		],
		button: "Onaylayın",
		cancel: "İptal Edin",
		switchAccount: "Hesap Değiştir",
		success: "Bağlanıyor..."
	},
	confirmed: {
		title: "Başarılı!",
		subtitle: "Streamlabs ID'niz oluşturuldu ve {company} hesap bağlandı.",
		text: "Streamlabs ID'nizi tüm Streamlabs ürünleri için kullanabilirsiniz. Mevcut hesaplarınız varsa her uygulama içerisinden bu ID'ye bağlayabilirsiniz.",
		button: "Kapat"
	},
	error: {
		user: "Kullanıcı girişi başarısız. Lütfen tekrar giriş yapmayı deneyin veya destek ile iletişime geçin."
	}
};
var confirmCard = {
	confirm: {
		title: "{company} Bağlantısını onaylayın",
		subtitle: "Eşleşen bir e-postaya sahip bir hesap bulduk. Bu hesabı Streamlabs ID ile birleştirmek ister misiniz?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Streamlabs ID aracılığıyla sağladığınız e-posta ve şifre ile {company} girişi yapabileceksiniz.",
			"ID'nizle Streamlabs'in tüm diğer ürünlerine erişebilir ve varsa diğer mevcut hesaplarınıza bağlanabilirsiniz.",
			"Şirket hesabınız bu değişiklikten etkilenmeyecektir."
		],
		button: "Onaylayın",
		cancel: "İptal Edin",
		switchAccount: "Hesap Değiştir",
		success: "Bağlanıyor..."
	},
	confirmed: {
		title: "Başarılı!",
		subtitle: "Streamlabs ID'niz oluşturuldu ve {company} hesap bağlandı.",
		text: "Streamlabs ID'nizi tüm Streamlabs ürünleri için kullanabilirsiniz. Mevcut hesaplarınız varsa her uygulama içerisinden bu ID'ye bağlayabilirsiniz.",
		button: "Kapat"
	},
	error: {
		user: "Kullanıcı girişi başarısız. Lütfen tekrar giriş yapmayı deneyin veya destek ile iletişime geçin."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Kimliğinizle bağlı bir {company} hesabı zaten mevcut",
		subtitle: "Bağlı hesabın bağlantısını kaldırmak ve mevcut Streamlabs hesabınızla bağlamak ister misiniz?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Streamlabs ID aracılığıyla sağladığınız e-posta ve şifre ile Streamlabs’e giriş yapabileceksiniz.",
			"ID'nizle Streamlabs'in tüm diğer ürünlerine erişebilir ve varsa diğer mevcut hesaplarınıza bağlanabilirsiniz.",
			"Streamlabs hesabınız bu değişiklikten etkilenmeyecektir."
		],
		button: "Onaylayın",
		cancel: "İptal Edin",
		switchAccount: "Hesap Değiştir",
		success: "Bağlanıyor...",
		agreeLabel: "Bu bağlantıyı sağlayarak Streamlabs ID'ye bağlı mevcut {company} hesabına erişimimi kaybedeceğimi anlıyorum."
	},
	confirmed: {
		title: "Başarılı!",
		subtitle: "Streamlabs ID'niz oluşturuldu ve {company} hesap bağlandı.",
		text: "Streamlabs ID'nizi tüm Streamlabs ürünleri için kullanabilirsiniz. Mevcut hesaplarınız varsa her uygulama içerisinden bu ID'ye bağlayabilirsiniz.",
		button: "Kapat"
	},
	error: {
		user: "Kullanıcı girişi başarısız. Lütfen tekrar giriş yapmayı deneyin veya destek ile iletişime geçin."
	}
};
var loginCard = {
	title: "Oturum Açın",
	lead: "<company>{company}</company> uygulamalarında <id>Streamlabs ID</id> ile oturum açın",
	accountExists: "Zaten bir <b>Streamlabs ID</b>’niz var gibi görünüyor. E-postanız ile oturum açmayı deneyin.",
	forgotPassword: "Şifrenizi mi unuttunuz?",
	successText: "Başarılı! Yeniden yönlendiriliyor...",
	signInTitle: "Bir platformda oturum açın"
};
var loginSourcesCard = {
	title: "Oturum Açın",
	lead: "E-posta/şifre ile oturum açın",
	withSlId: "Streamlabs ID ile oturum açın",
	noAccountMessage: "Bu oturum açma yöntemiyle ilişkilendirilmiş bir hesap göremiyoruz. Lütfen farklı bir oturum açma yöntemi deneyin veya henüz yapmadıysanız <signup>Kaydolun</signup>.",
	accountExistsMessage: "Twitch e-posta adresiniz zaten bir Streamlabs ile ilişkilendirildi. Lütfen Streamlabs e-postanız ve şifreniz ile oturum açmayı deneyin."
};
var resetPasswordForm = {
	emailPlaceholder: "E-posta",
	codePlaceholder: "6-8 Hanelik E-posta Kodu",
	tfaCodePlaceholder: "İki Faktörlü Kimlik Doğrulayıcısı Kodu",
	newPasswordPlaceholder: "Yeni Şifre",
	tfaError: "Sıfırlama kodu 6 ile 10 karakter arasında olmalıdır",
	next: "Kodu aldınız mı?",
	back: "Şifremi Unuttum Sayfasına Geri Dönün",
	buttonText: "Şifreyi Değiştirin",
	successText: "Şifre Başarılı Bir Şekilde Sıfırlandı",
	create: {
		back: "Başlangıca dön",
		buttonText: "Şifreyi Ayarla",
		successText: "Şifre Başarılı Bir Şekilde Ayarlandı"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Mevcut Şifre",
	newPasswordPlaceholder: "Yeni Şifre",
	newPasswordConfirmationPlaceholder: "Yeni Şifreyi Doğrulayın",
	buttonText: "Şifreyi Değiştirin",
	successText: "Şifre başarılı bir şekilde güncellendi",
	newPasswordConfirmationError: "Yeni şifreler uyuşmuyor",
	back: "Pano’ya geri dönün"
};
var changePasswordCard = {
	title: "Şifrenizi Değiştirin",
	lead: "Mevcut şifrenizi ve yeni şifrenizi aşağıya girin.",
	successText: "Şifre başarılı bir şekilde güncellendi"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6 haneli kimlik doğrulama kodu/8 haneli yedekleme kodu",
	successText: "İki Faktörlü Kimlik Doğrulama özelliği başarılı bir şekilde kaldırıldı",
	removeBtn: "Onaylayın ve Kaldırın"
};
var removeTfaCard = {
	title: "2 Faktörlü Doğrulamayı Kaldır",
	lead: "Hesabınızdan İki Faktörlü Kimlik Doğrulama özelliğini kaldırmak için aşağıya İki Faktörlü Kimlik Doğrulama onay kodunu girin.",
	successText: "İki Faktörlü Kimlik Doğrulama özelliği başarılı bir şekilde kaldırıldı",
	back: "Pano’ya geri dönün"
};
var verifyEmailForm = {
	codePlaceholder: "E-postaya gelen 8 haneli kod",
	tfaCodePlaceholder: "İki Faktörlü Kimlik Doğrulayıcısı Kodu",
	emailPlaceholder: "E-posta Adresi",
	buttonText: "E-postayı Doğrulayın",
	successText: "E-posta Başarılı Bir Şekilde Doğrulandı",
	requestBtn: "Yeni Kod Talep Edin",
	requestingBtn: "Talep Ediliyor...",
	requestSuccess: "E-postanıza bir kod gönderildi",
	requestAgain: "{seconds} saniye içinde Tekrar Talep Edin",
	tfaError: "Sıfırlama kodu 6 ile 10 karakter arasında olmalıdır",
	back: "Geri Gidin"
};
var signupCard = {
	title: "Kaydolun",
	lead: "<company>{company}</company> uygulamalarını kullanmak için bir <id>Streamlabs ID</id> oluşturun",
	successText: "Başarılı! Yeniden yönlendiriliyor..."
};
var signupSourcesCard = {
	title: "Kaydolun",
	lead: "<company>{company}</company> uygulamalarını kullanmak için bir <id>Streamlabs ID</id> oluşturun",
	withSlId: "Streamlabs ID oluşturun"
};
var connectCard = {
	connect: {
		title: "Şu uygulamalara devam etmek için bir hesap seçin:",
		lead: "<b>{company}</b>",
		authorize: "Yetkilendirin",
		authorizeSuccess: "Başarılı!",
		cancel: "İptal Edin",
		disclaimer: {
			streamlabs: "Devam etmek, Streamlabs ID’nizin (ad, e-posta adresi, dil tercihi ve profil fotoğrafı) <b>{company}</b> uygulamalarıyla paylaşılmasını sağlar. <b>{company}</b> ile bir hesabı onaylayarak <b>{company}</b>‘un <privacy>gizlilik politikası</privacy> ve <terms>hüküm ve koşullarına</terms> onay vermiş olursunuz.",
			"default": "Streamlabs devam etmek için isminizi, e-posta adresinizi, dil tercihinizi ve profil fotoğrafınızı <b>{company}</b> uygulamalarıyla paylaşır. <b>{company}</b> ile bir hesabı onaylayarak <b>{company}</b>‘un <privacy>gizlilik politikası</privacy> ve <terms>hüküm ve koşullarına</terms> onay vermiş olursunuz."
		},
		emailRequired: "İlerlemeden önce e-posta doğrulaması gereklidir",
		tfaRequired: "İlerlemeden önce İki Faktörlü Kimlik Doğrulama gereklidir"
	},
	login: {
		title: "{company} uygulamasında oturum açın",
		lead: "Hesapları bağlamak için oturum açmanız gereklidir",
		loginBtn: "Oturum açmak için ilerleyin"
	},
	error: {
		title: "{company} uygulamasında oturum açın",
		lead: "Talebiniz şu anda yetkilendirilemiyor.",
		verifyEmail: "E-postayı Doğrulayın",
		verify2fa: "2FA'yı Doğrulayın"
	},
	"switch": {
		btn: "Başka bir hesap kullanın"
	}
};
var appsDropdown = {
	label: "Streamlabs ürünleri ve uygulamaları",
	viewMore: "Genişlet",
	viewLess: "Daralt"
};
var platformButtons = {
	loginWithPlatform: "Bir platformda oturum açın",
	signUpWithPlatform: "Bir platformda kaydolun",
	signUpLead: "Birçok platforma canlı yayını destekliyoruz, bunlar sadece kayıt seçenekleridir."
};
var ultraCheckoutCard = {
	title: "<b>Streamlabs Ultra</b> ile canlı yayınlarınızı, markanızı, düzenlemelerinizi ve daha fazlasını bir üst seviyeye çıkarın",
	badge: "İçindekiler: <b>{planName}</b>",
	totalValue: "{price, currency} değeri",
	price: {
		month: "{price, currency}/ay",
		year: "{price, currency}/yıl"
	},
	description: {
		month: "<b>Streamlabs Desktop</b>, <b>Konsol</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> ve daha fazlasını içeren premium özelliklere tek seferde makul bir fiyattan erişim sağlayın.",
		year: "<b>Streamlabs Desktop</b>, <b>Konsol</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> ve daha fazlasını içeren premium özelliklere tek seferde makul bir fiyattan erişim sağlayın."
	},
	seeIncluded: "Daha Fazla Bilgi",
	buyNow: "Yükselt"
};
var ultraCheckoutBanner = {
	title: "<b>Streamlabs Ultra</b> ile canlı yayınlarınızı, markanızı, düzenlemelerinizi ve daha fazlasını bir üst seviyeye çıkarın",
	badge: "İçindekiler: <b>{planName}</b>",
	totalValue: "{price, currency} değeri",
	price: {
		month: "{price, currency}/ay",
		year: "{price, currency}/yıl"
	},
	description: {
		month: "<b>Streamlabs Desktop</b>, <b>Konsol</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> ve daha fazlasını içeren premium özelliklere tek seferde makul bir fiyattan erişim sağlayın. <link />",
		year: "<b>Streamlabs Desktop</b>, <b>Konsol</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> ve daha fazlasını içeren premium özelliklere tek seferde makul bir fiyattan erişim sağlayın. <link />"
	},
	seeIncluded: "Daha Fazla Bilgi",
	buyNow: "Yükselt"
};
var connect = {
	waitMessage: "Veriler birleştiriliyor. Lütfen bu pencereyi kapatmayın."
};
var verifyPasswordCard = {
	success: "Şifre başarılı bir şekilde doğrulandı",
	title: "Doğrulamak için lütfen tekrar yetkilendirin",
	lead: "Streamlabs ID’nizi güncellemek için lütfen mevcut e-posta ve şifrenizle oturum açın.",
	buttonText: "İleri"
};
var emailChangeForm = {
	agreeError: "Lütfen bu eylemi anladığınızı doğrulayın",
	buttonText: "İleri",
	emailPlaceholder: "Yeni E-posta Adresi",
	agreeText: "Doğrulama tamamlandığında Streamlabs ID’sinin bağlı olduğu tüm Streamlabs ürünlerinde değişeceğini anlıyorum."
};
var verifyNewEmailCard = {
	title: "Streamlabs ID’nizi değiştirin",
	lead: "Streamlabs ID’si olarak kullanacağınız yeni e-posta adresini girin. Bu e-posta adresine 6-8 haneli bir doğrulama kodu göndereceğiz.",
	successText: "Yeni e-posta adresi kullanılabilir"
};
var verifyNewEmailOwnershipCard = {
	title: "Güncellenmiş Streamlabs ID’nizi doğrulayın",
	lead: "E-postanıza Streamlabs’ten 8 haneli kod gelip gelmediğini kontrol edin ve gelmişse kodu aşağıya girin.",
	buttonText: "Onaylayın",
	back: "Geri",
	codePlaceholder: "E-postaya gelen 8 haneli kod",
	successText: "E-posta başarılı bir şekilde doğrulandı"
};
var verifyTfaCard = {
	title: "2 faktörlü doğrulama kodu",
	lead: "Kimlik doğrulama uygulamanızdaki 6 haneli doğrulama kodunu girin.",
	codePlaceholder: "6 haneli kod",
	buttonText: "Onaylayın",
	successText: "2 Faktörlü doğrulama onaylandı",
	back: "Geri"
};
var ageGateForm = {
	ageLabel: "Doğum Tarihi",
	agePlaceholder: "AA/GG/YYYY"
};
var ageGateCard = {
	title: "Hesap kurulumunu tamamla",
	lead: {
		years: "Bir hesap oluşturmak için {years} yaş veya üzeri olmalısınız. <br />Kurulumu tamamlamak için doğum tarihinizi girin.",
		noYears: "Bir hesap oluşturmak için doğum tarihinizi girmelisiniz. <br />Kurulumu tamamlamak için bu bilgiyi girin."
	},
	successText: "Tebrikler! Hesap kurulumu tamamlandı."
};
var trTR = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { trTR as t };
//# sourceMappingURL=tr-TR.es.js.map
